import type { PostProcessorModule } from 'i18next';

const capitalizePostProcessor: PostProcessorModule = {
  type: 'postProcessor',
  name: 'capitalize',
  process: (value: string, key: string, options: any) => {
    // Only process if the option is set
    if (!options?.capitalize) return value;

    // Handle empty strings
    if (!value) return value;

    // If titleCase option is set, capitalize each word
    if (options.titleCase) {
      return value
        .split(' ')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
    }

    // Otherwise just capitalize first letter
    return value.charAt(0).toUpperCase() + value.slice(1);
  }
};

export default capitalizePostProcessor;